import * as React from "react";
import type { SVGProps } from "react";
const SvgLatvia = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <path
      d="M0 0h1280v720H0z"
      style={{
        fill: "#9d3039",
      }}
    />
    <path
      d="M0 288h1280v144H0z"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
);
export default SvgLatvia;
